import { LANGUAGES } from "./languages.c";

const FIRST_PATH_SEGMENT = window.location.pathname.split("/")[1];

export const URL_LANGUAGE =
  FIRST_PATH_SEGMENT === LANGUAGES.JP
    ? LANGUAGES.JP
    : FIRST_PATH_SEGMENT === LANGUAGES.CN
    ? LANGUAGES.CN
    : LANGUAGES.EN;
